import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { BehaviorSubject } from 'rxjs';
import { ResetBookingState } from '../states/bookings/booking.actions';
import { ResetOrderState } from '../states/orders/orders.action';
import { ResetPartnerState } from '../states/partner/partner.action';
import { ResetUsersState } from '../states/users/user.actions';

const TOKEN_KEY = 'auth-token';
const ORDER_TOKEN_KEY = 'order-auth-token';

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  authenticationState = new BehaviorSubject<boolean>(!!localStorage.getItem(TOKEN_KEY));
  private isHandlingUnauthorizedSession = false;

  constructor(
    private router: Router,
    private store: Store
  ) {}

  setAuthenticated(isAuthenticated: boolean): void {
    this.isHandlingUnauthorizedSession = false;
    this.authenticationState.next(isAuthenticated);
  }

  logout(navigateToLogin: boolean = true): void {
    this.clearSessionState();

    if (navigateToLogin && this.router.url !== '/logga-in') {
      void this.router.navigateByUrl('/logga-in');
    }
  }

  handleUnauthorizedSession(): void {
    if (this.isHandlingUnauthorizedSession) {
      return;
    }

    this.isHandlingUnauthorizedSession = true;
    this.clearSessionState();

    if (this.router.url !== '/logga-in') {
      void this.router.navigateByUrl('/logga-in');
    }
  }

  private clearSessionState(): void {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(ORDER_TOKEN_KEY);
    this.store.dispatch(new ResetOrderState());
    this.store.dispatch(new ResetUsersState());
    this.store.dispatch(new ResetBookingState());
    this.store.dispatch(new ResetPartnerState());
    this.authenticationState.next(false);
  }
}
